import classNames from 'classnames/bind';
import React, { PropsWithChildren } from 'react';
import styles from './ListTitleContainer.module.scss';

const cx = classNames.bind(styles);

interface RecentAndSavedSuggestsListContainerProps extends PropsWithChildren {
  title: string;
}

const ListTitleContainer = ({ title, children }: RecentAndSavedSuggestsListContainerProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      <h1 className={cx('list-title')}>{title}</h1>
      {children}
    </div>
  );
};

export default ListTitleContainer;
